function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.6660151mm",
    height: "7.6533198mm",
    viewBox: "0 0 5.6660151 7.6533198",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.123675,-58.209549)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.4321527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 84.34489,64.860916 q 0.820313,0 1.274414,-0.795898 0.454102,-0.800782 0.454102,-2.25586 0,-1.274414 -0.424805,-1.943359 -0.419922,-0.673828 -1.225586,-0.673828 -0.81543,0 -1.259766,0.742187 -0.439453,0.742188 -0.439453,2.128907 0,1.342773 0.419922,2.070312 0.424805,0.727539 1.201172,0.727539 z m 2.626953,-3.110351 q 0,1.728515 -0.74707,2.797851 -0.742188,1.064453 -1.928711,1.064453 -1.12793,0 -1.811523,-0.922851 -0.678711,-0.927735 -0.678711,-2.470703 0,-1.75293 0.722656,-2.753907 0.722656,-1.005859 1.977539,-1.005859 1.181641,0 1.821289,0.859375 0.644531,0.859375 0.644531,2.431641 z",
    style: {
      fontSize: 10,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit0);
export default __webpack_public_path__ + "static/media/digit-0.8df5c677db7ebcb41ee98189a8e93be7.svg";
export { ForwardRef as ReactComponent };